import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import CustomerDetail from './CustomerDetail';

const CreateForceLoginMutation = gql`
  mutation createForceLogin($customerId: String!) {
    createForceLogin(customerId: $customerId) {
      customerId
      callbackUrl
    }
  }
`;

const UpdateJSONPricesDownloadTokenMutation = gql`
  mutation updateJSONPricesDownloadToken($customerId: String!, $newToken: String) {
    updateJSONPricesDownloadToken(id: $customerId, token: $newToken)
  }
`;

export default compose(
  graphql<any, GQL.IQuery>(CreateForceLoginMutation, {
    name: 'createForceLogin'
  }),
  graphql<any, GQL.IQuery>(UpdateJSONPricesDownloadTokenMutation, {
    name: 'updateJSONPricesDownloadToken'
  }),
)(CustomerDetail);



// WEBPACK FOOTER //
// ./src/scenes/Customers/CustomerDetail/index.tsx